export const getModalType = (state) => state.reducerModal.modalType;
export const getModalProps = (state) => state.reducerModal.props;
